import { IS_PRODUCTION } from 'utils/check-environment/check-environment';
import {
  getLocalStorage,
  setLocalStorage,
  LocalStorageKeys,
} from 'utils/localStorage';
import { localStorageKeyExists } from '../localStorage';

export const setTestableFlag = (isEnabled: boolean = false): void => {
  if (!IS_PRODUCTION && typeof window !== 'undefined') {
    setLocalStorage(LocalStorageKeys.testable, isEnabled);
  }
};

export const getQueryParams = (): Record<string, string> => {
  if (typeof window !== 'undefined') {
    const urlParams = new URLSearchParams(window.location.search);

    const paramsObject = Object.fromEntries(urlParams.entries());

    return paramsObject;
  }

  return {};
};

/**
 * Evaluate testableFeatures in the following priority order
 * 1. If on production it should always be set to false
 * 2. Set from query string parameter flag 'testableFeaturesEnabled' (Note that in other apps this might be called enableTestableFeatures)
 *    |to turn OFF append &testableFeaturesEnabled || &testableFeaturesEnabled=false || &testableFeaturesEnabled=0
 *    |to turn ON append  &testableFeaturesEnabled=1 (where 1 can be any value that is truthy)
 * 3. Check local storage value for 'testableFeaturesEnabled'
 */
export function getTestableFeaturesEnabled(query: any = {}): boolean {
  // 1. Evaluate if production
  if (IS_PRODUCTION) {
    return false;
  }

  // 2. Evaluate Query string
  let { testable: queryStringTestableFlag } = query;

  if (query) {
    queryStringTestableFlag = queryStringTestableFlag?.toString();

    if (queryStringTestableFlag !== undefined) {
      const evaluateTestableFromQueryString =
        queryStringTestableFlag.includes('false') ||
        queryStringTestableFlag.includes('0')
          ? false
          : !!queryStringTestableFlag || queryStringTestableFlag == '';

      setTestableFlag(evaluateTestableFromQueryString);

      return evaluateTestableFromQueryString;
    }
  }

  // 3. Evaluate Local Storage
  const localStorageTestableFlag = getLocalStorage<boolean | string>(
    LocalStorageKeys.testable
  );

  if (localStorageTestableFlag !== null) {
    return localStorageTestableFlag === 'false' ||
      localStorageTestableFlag === '0'
      ? false
      : !!localStorageTestableFlag;
  } else if (localStorageKeyExists(LocalStorageKeys.testable)) {
    return false;
  }

  const nonProductionDefault = true;
  setTestableFlag(nonProductionDefault); // set the browser storage value for consistency and visibility
  return nonProductionDefault; // default is true as we're not in production
}

/**
 * FE Mock Server can only be used if testable is on
 * FE Mock Server should be used with the https://github.com/workivate/fe-mock-server repo
 * This runs locally and fakes up BE responses for local development on localhost:3012
 * e.g. feMockServerEnabled: "mfaSetup" will fake up the MFA setup responses
 */
export function getFeMockServerEnabled(): string | null {
  const localStorageMockServerValue = getLocalStorage<string | null>(
    LocalStorageKeys.feMockServerEnabled
  );

  return localStorageMockServerValue;
}
